export default __webpack_public_path__ + "static/media/loading.67d404f3.svg";